import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_ASIA_PROD } from "../consts.js"

export const msig = {
	// msig_uat
	"msig-uat-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_ASIA_PROD },
	// msig_test
	"msig-test-studio.dev.asia.covergo.cloud": { 
		appConfig: { tenantId: "msig_test", appId: "covergo_crm" }, 
		envConfig: {
			COVERGO_GRAPHQL: "https://api.dev.msig.asia.covergo.cloud/graphql",
			COVERGO_FILE_SYSTEM: "https://api.dev.msig.asia.covergo.cloud/api/v1/files"
		}
	},
	// msig_dev
	"studio.msig.dev.ap-east-1.covergo.cloud": {
		appConfig: { tenantId: "msig_dev", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.msig.dev.ap-east-1.covergo.cloud/graphql",
			COVERGO_FILE_SYSTEM: "https://api.msig.dev.ap-east-1.covergo.cloud/api/v1/files"
		}
	},

	// msig_qa
	"studio.msig.qa.ap-east-1.covergo.cloud": {
		appConfig: { tenantId: "msig_qa", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.msig.qa.ap-east-1.covergo.cloud/graphql",
			COVERGO_FILE_SYSTEM: "https://api.msig.qa.ap-east-1.covergo.cloud/api/v1/files"
		}
	},

	// msig_qa-rs (external)
	"studio.msig.qa-rs.ap-east-1.covergo.cloud": {
		appConfig: { tenantId: "msig_qa", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.msig.qa-rs.ap-east-1.covergo.cloud/graphql",
			COVERGO_FILE_SYSTEM: "https://api.msig.qa-rs.ap-east-1.covergo.cloud/api/v1/files",
		},
	},

	// msig_qa-rs (internal)
	"studio.qa-rs.covergoaws.msighkcloud.net": {
		appConfig: { tenantId: "msig_qa", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.qa-rs.covergoaws.msighkcloud.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.qa-rs.covergoaws.msighkcloud.net/api/v1/files",
		},
	},

	// msig_prod
	"studio.medigo.msig.com.hk": {
		appConfig: { tenantId: "msig_prod", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.medigo.msig.com.hk/graphql",
			COVERGO_FILE_SYSTEM: "https://api.medigo.msig.com.hk/api/v1/files",
		},
	},

	// msig_prod DR site
	"studio.medigo-rs.msig.com.hk": {
		appConfig: { tenantId: "msig_prod", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.medigo-rs.msig.com.hk/graphql",
			COVERGO_FILE_SYSTEM: "https://api.medigo-rs.msig.com.hk/api/v1/files",
		},
	},

	// msig_uat
	"msig-studio.uat.msig.asia.covergo.net": {
		appConfig: { tenantId: "msig_uat", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.uat.msig.asia.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.uat.msig.asia.covergo.net/api/v1/files",
		},
	},
	"studio.uat.medigo.msig.com.hk": {
		appConfig: { tenantId: "msig_uat", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.uat.medigo.msig.com.hk/graphql",
			COVERGO_FILE_SYSTEM: "https://api.uat.medigo.msig.com.hk/api/v1/files",
		},
	},
	
	// msig_prod (production rehearsal migration)
	"msig-studio.prod.msig.asia.covergo.net": {
		appConfig: { tenantId: "msig_prod", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.prod.msig.asia.covergo.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.prod.msig.asia.covergo.net/api/v1/files",
		},
	},

	// msig_prod
	"studio.prod.covergoaws.msighkcloud.net": {
		appConfig: { tenantId: "msig_prod", appId: "covergo_crm" },
		envConfig: {
			COVERGO_GRAPHQL: "https://api.prod.covergoaws.msighkcloud.net/graphql",
			COVERGO_FILE_SYSTEM: "https://api.prod.covergoaws.msighkcloud.net/api/v1/files"
		}
	},
}
